// extracted by mini-css-extract-plugin
export default {"rowWrapper":"quoteDdp_rowWrapper__XyvYT"};